// Re-encodes a WebP (or very large) photo as a JPEG in the browser before
// upload, so headshots can always go into the leader bios PDF (the backend's
// PDF library only embeds JPG/PNG). Long side capped at maxSide pixels.
// JPGs/PNGs already small enough are returned untouched. Falls back to the
// original file if the browser can't decode it.
export async function toPrintableImage(file, { maxSide = 1600, quality = 0.88 } = {}) {
  if (!file || !file.type.startsWith('image/')) return file;
  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return file;
  }
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const printable = file.type === 'image/jpeg' || file.type === 'image/png';
  if (printable && scale === 1) { bitmap.close?.(); return file; }

  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff'; // transparent areas become white, not black
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close?.();
  const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
  if (!blob) return file;
  return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
}
